<cap-functionbar>
  <nav aria-label="breadcrumb">
    <div class="d-flex mt-0">
      <ol class="breadcrumb p-0 m-0 ms-3">
        @if (breadcrumbHolder.length === 0) {
          <div>
            <li class="transparentItem">|</li>
          </div>
        }
        @for (breadcrumb of breadcrumbHolder; track breadcrumb; let last = $last; let i = $index) {
          <li [ngClass]="{ 'close-navigation': last, active: breadcrumb.active }" class="breadcrumb-item">
            @if (breadcrumb.active) {
              <span>
                <span class="breadcrumbActive">{{ breadcrumb.label | translate }}</span>
              </span>
            } @else {
              <span (click)="breadcrumbClicked(i)" class="breadcrumbNotActive">{{ breadcrumb.label | translate }}</span>
            }
          </li>
        }
      </ol>
    </div>
  </nav>

  <cap-functionbar-list align="right">
    <div class="form-check form-check-inline historyButton">
      <input
        (change)="onSelectHistorisiert()"
        [disabled]="!hasPermissionAnzeigeHistorischeEintraege"
        [ngModel]="historyModeCheckbox"
        class="form-check-input"
        id="flexCheckDefault"
        type="checkbox"
        value="" />
      <label class="form-check-label noselect" for="flexCheckDefault">
        {{ "GeschichteAnzeigen" | translate }}
      </label>
    </div>

    @if (timepointCtx.hasTimepointListEntry) {
      <span [ngbTooltip]="'Aktueller Betrachtungskontext' | translate" class="breadcrumbActive">{{
        timepointCtx.timepointListEntry | formatTimepoint
      }}</span>
    } @else {
      <button (click)="resetTimepoint()" class="btn" style="background-color: transparent" type="button">
        <i class="far fa-eye"></i>
      </button>
      <span [ngbTooltip]="'Aktueller Betrachtungskontext' | translate" class="breadcrumbActive form-check-inline">{{
        timepointCtx.timepoint | date: "HH:mm dd.MM.yyyy"
      }}</span>
    }
    <ng-template #timepoint>
      <button (click)="resetTimepoint()" class="btn" style="background-color: transparent" type="button">
        <i class="far fa-eye"></i>
      </button>
      <span [ngbTooltip]="'Aktueller Betrachtungskontext' | translate" class="breadcrumbActive form-check-inline">{{
        timepointCtx.timepoint | date: "HH:mm dd.MM.yyyy"
      }}</span>
    </ng-template>
  </cap-functionbar-list>
</cap-functionbar>
